const API_URLs = {
  development: 'https://api-staging.tokenza.io/',
  // production: 'https://api-staging.tokenza.io/',
  production: 'https://api.tokenza.io/'
}

export const API_URL = API_URLs[process.env.NODE_ENV];